import { createTheme } from '@mui/material/styles';
import { primaryColor, whiteColor } from '../../assets/styles/jss/main';

const vvmtTheme = createTheme({
  palette: {
    primary: {
      main: primaryColor,
      contrastText: whiteColor,
    },
  },
});

export default vvmtTheme;